import React from 'react'
import { ArrowLeft } from 'lucide-react'
import { PageHeaderContainer, CompactPageHeader } from './headers.styles'

export interface PageHeaderProps {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  gradient?: string
  onBack?: () => void
  backLabel?: string
  actions?: React.ReactNode
  compact?: boolean
  className?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  gradient,
  onBack,
  backLabel = 'Back',
  actions,
  compact = false,
  className,
}) => {
  const HeaderComponent = compact ? CompactPageHeader : PageHeaderContainer

  return (
    <HeaderComponent $gradient={gradient} className={className}>
      {onBack && (
        <button className="back-button" onClick={onBack}>
          <ArrowLeft size={16} />
          {backLabel}
        </button>
      )}

      <div className="header-content">
        <h1 className="page-title">
          {icon && <span className="title-icon">{icon}</span>}
          {title}
        </h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>

      {actions && <div className="header-actions">{actions}</div>}
    </HeaderComponent>
  )
}

export default PageHeader
